var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
var spinAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"], ["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  width: 25px;\n  height: 25px;\n  border: 2px solid rgba(0, 0, 0, 0.1);\n  border-left-color: ", ";\n  border-radius: 50%;\n  animation: ", " 1s linear infinite;\n  margin-left: 5px;\n"], ["\n  display: inline-block;\n  width: 25px;\n  height: 25px;\n  border: 2px solid rgba(0, 0, 0, 0.1);\n  border-left-color: ", ";\n  border-radius: 50%;\n  animation: ", " 1s linear infinite;\n  margin-left: 5px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.purple;
}, spinAnimation);
export default function KissSpinner() {
    return _jsx(Container, {});
}
var templateObject_1, templateObject_2;
